// Libs
import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

// Components
import ReportableIcon from '../../../../Products/Card/ReportableIcon';
import Rating from '../../../../Rating';
import DetailsInfo from '../../../DetailsInfo';
import canRateProduct from '../../../../../utils/canRateProduct';

const CartCardDescription = ({
  product,
  onOpenModal,
  reviewOrderPage,
  isTabletMode,
  isMobileMode,
  placedOrder,
  pendingApproval,
  orderedProduct,
  isUnavailableForOrder,
  count,
  addOneProduct,
  removeOneProduct,
  setCount,
  isOverLimitProduct,
  kit,
  nums,
  unavailableLabel,
  addressesCount,
  readOnly,
  KitQtyComponent,
  classes,
}) => {
  const {
    product_description: description,
    reportable: isReportable,
    size_vers: sizeVers,
  } = product || {};
  const isRatable = canRateProduct(product);

  return (
    <div className={classes.descriptionContainer}>
      <Stack
        className={classes.descAndSize}
        direction="row"
        justifyContent="space-between">
        <div>
          <div onClick={onOpenModal} className={classes.description}>
            {description}
          </div>
          <Typography variant="textSm">{sizeVers}</Typography>
        </div>
        {isReportable && (
          <Box alignContent="end" ml={1}>
            <ReportableIcon />
          </Box>
        )}
      </Stack>
      {reviewOrderPage && isTabletMode && !isMobileMode && isRatable && (
        <Rating
          withTooltip={reviewOrderPage ? placedOrder?.id : true}
          product={product}
        />
      )}
      <DetailsInfo
        pendingApproval={pendingApproval}
        orderedProduct={orderedProduct}
        isUnavailableForOrder={isUnavailableForOrder}
        product={product}
        cartProps={{
          count,
          addOne: addOneProduct,
          removeOne: removeOneProduct,
          setCount,
        }}
        isOverLimit={isOverLimitProduct}
        kit={kit}
        nums={nums}
        placedOrder={placedOrder}
        unavailableLabel={unavailableLabel}
        shippingAddresses={addressesCount}
        readOnly={readOnly}
        KitQtyComponent={KitQtyComponent}
      />
    </div>
  );
};

export default CartCardDescription;
